import axios from "axios";
import moment from "moment";

const getHijriMonthDates = (dateToConvert, hijriMonth) => {
    // eslint-disable-next-line no-useless-concat
    const urlToGo = 'https://www.islamicity.org/global/scripts/hijri-converter/index-mhk.php?q=' + dateToConvert + '&to=hijri&isMonth=1';
    return new Promise((resolve, reject) => {
        axios.get(urlToGo)
            .then(resolve).catch(reject);
    });

}

const getGregorianMonthDates = (dateToConvert, hijriMonth) => {
    // eslint-disable-next-line no-useless-concat
    const urlToGo = 'https://www.islamicity.org/global/scripts/hijri-converter/index-mhk.php?q=' + dateToConvert + '&to=greg&isMonth=1';
    return new Promise((resolve, reject) => {
        axios.get(urlToGo)
            .then(resolve).catch(reject);
    });

}
const hijriToGreg = (year, month, data) => {
   // console.log(hijriToGreg);
    const monthDetail = [];
    for (let i = 1; i <= 30; i++) {
        if (data[`${year}-${month}-${i}`]) {
            monthDetail.push({
                hijri: i,
                greg: moment(data[`${year}-${month}-${i}`].split("|")[0], 'YYYY-M-D').format('MMM DD YYYY, ddd')
            })
        }
    }
    return monthDetail;
}

const gregToHijri = (year, month, data) => {
    const monthDetail = [];
    for (let i = 1; i <= 31; i++) {
        if (data[`${year}-${month}-${i}`]) {
            monthDetail.push({
                hijri: data[`${year}-${month}-${i}`].split("/")[1].split(",")[0],
                greg: moment(`${year}-${month}-${i}`, 'YYYY-M-D').format('MMM DD, ddd')
            })
        }
    }
    return monthDetail;
}

const getSingleHijriMonth = (gregYear, gregMonth) => {
    let content_url = `${window.settings.monthsContentJSBasePath}/${gregYear}.json?ver=${window.settings.ver}`; 
    if(window.settings.isLoadCalenderDataFromInAppFolder)
    {
        content_url = process.env.PUBLIC_URL + `/hijri-gregorian-dates/${gregYear}.json?ver=${window.settings.ver}`; 
    }

    return new Promise((resolve, reject) => {
        fetch(content_url)
            .then(response => {
                response.json()
                    .then(response => {
                        const hijriYear = moment(response[`${gregYear}-${gregMonth}-1`].split("|"), "YYYY-M-D").format("M");
                        resolve(hijriYear);
                    }).catch(reject);
            }).catch(reject)
    })
}

const getHijriYear = (gregYear, gregMonth) => {
    let content_url = `${window.settings.monthsContentJSBasePath}/${gregYear}.json?ver=${window.settings.ver}`; 
    if(window.settings.isLoadCalenderDataFromInAppFolder)
    {
        content_url = process.env.PUBLIC_URL + `/hijri-gregorian-dates/${gregYear}.json?ver=${window.settings.ver}`; 
    }

    return new Promise((resolve, reject) => {
        fetch(content_url)
            .then(response => {
                response.json()
                    .then(response => {
                        const hijriMonth = moment(response[`${gregYear}-${gregMonth}-1`].split("|"), "YYYY-M-D").format("YYYY");
                        resolve(hijriMonth);
                    }).catch(reject);
            }).catch(reject);
    })

}

const getHijriMonthDetail = (hijriYear, month) => {
    let content_url = `${window.settings.monthsContentJSBasePath}/${hijriYear}-HIJRI.json?ver=${window.settings.ver}`; 
    
    if(window.settings.isLoadCalenderDataFromInAppFolder)
    {
       content_url = process.env.PUBLIC_URL + `/hijri-gregorian-dates/${hijriYear}-HIJRI.json?ver=${window.settings.ver}`;  
    }
    
    return new Promise((resolve, reject) => {
        fetch(content_url)
            .then(response => {
                response.json()
                    .then(response => {
                        resolve(hijriToGreg(hijriYear, month, response));
                    }).catch(reject);
            }).catch(reject)
    })

}

const getGregorianMonthDetail = (year, month) => {
    let content_url = `${window.settings.monthsContentJSBasePath}/${year}.json?ver=${window.settings.ver}`; 
    if(window.settings.isLoadCalenderDataFromInAppFolder)
    {
        content_url = process.env.PUBLIC_URL + `/hijri-gregorian-dates/${year}.json?ver=${window.settings.ver}`; 
    }
    return new Promise((resolve, reject) => {
        fetch(content_url)
            .then(response => {
                
                response.json()
                    .then(response => {
                        resolve(gregToHijri(year, month, response));
                    }).catch(reject);
            }).catch(reject)
    })
}
export {
    getGregorianMonthDates,
    getHijriMonthDates,
    getHijriMonthDetail,
    getGregorianMonthDetail,
    getHijriYear,
    getSingleHijriMonth
}
